// Segments that carry qualitative SegmentAggregatedData and are therefore
// eligible for cross-segment comparison. Enforced as a UI-level filter in the
// comparison selector; the backend does not re-validate this list.

import { ALL_SEGMENT_NAMES } from './hackathon.js';

export const COMPARISON_ELIGIBLE_SEGMENTS: readonly string[] = ALL_SEGMENT_NAMES;

export type ComparisonEligibleSegment = string;

// Palette note: segment colors are resolved on the client via
// apps/chat/src/screens/Segmentation/components/comparisonV2/segmentColorByName.ts,
// which delegates to the position-based getSegmentColor(idx) used by the
// dashboard SegmentLegendBar. A name-based palette previously lived here;
// removing it forced V2 colors to match the dashboard legend.
